import ActionTypes from './actionTypes';

export function setUser(user) {
  return {
    type: ActionTypes.USER_SET,
    payload: user,
  };
}
